









import {Component, Vue} from 'vue-property-decorator';
import io from 'socket.io-client';

@Component({
    components: {
    },
})
export default class SocketTest extends Vue {

    // Temporary
    url = "operaguru.cosy.univie.ac.at:9092";

    mounted () {

        const socket = io(this.url);
        socket.on("next_chunk", (data: any) => {
            console.log("Chunk received:");
            console.log(data);
        });
        socket.on("prev_chunk", (data: any) => {
            console.log("Chunk retracted:");
            console.log(data);
        });
        socket.on("joined_room", (data: any) => {
            console.log("user joined room:");
            console.log(data);
        });
        socket.on("devchannel", (data: any) => {
            console.log("dev message");
            console.log(data);
        });
        socket.emit("join_profile", "2");
        console.log("send join profile 2");
    }
}
